<script>
    import LayoutGrid, {Cell} from "@smui/layout-grid";
    import Button from "@smui/button";
    import {Label} from "@smui/common";
    import Tab from "@smui/tab";
    import TabBar from "@smui/tab-bar";

    import SlideMonth from "../component/SlideMonth.svelte";
    import SlideYear from "./SlideYear.svelte";
    import Salary from "../component/Salary.svelte";
    import Extract from "../component/Extract.svelte";


    import html2pdf from 'html2pdf.js';

    import {globalState, api_url_public} from "../store/store.js";

    /** @type (array) result array from API */
    export let result = undefined;
    export let check = undefined;
    export let privateVersion;

    export let contentRef;

    globalState.update(state => ({
        ...state,
        l: check,
    }));

    function addWatermark() {
        const img = document.createElement('img');
        img.src = 'data:image/svg+xml;base64,PHN2ZyB...'; // base64 ici
        img.alt = 'watermark';
        img.id = 'pdf-watermark';
        img.style.position = 'absolute';
        img.style.top = '30%';
        img.style.left = '20%';
        img.style.width = '60%';
        img.style.transform = 'rotate(-30deg)';
        img.style.opacity = '0.1';
        img.style.zIndex = '0';
        img.style.pointerEvents = 'none';
        img.style.userSelect = 'none';
        img.style.maxHeight = 'none';

        document.body.appendChild(img);
    }

    function removeWatermark() {
        const img = document.getElementById('pdf-watermark');
        if (img) img.remove();
    }

    function generatePdf(filename) {
        const options = {
            margin: [0.1, 0.1, 0.1, 0.1],
            filename: filename,
            image: {type: 'jpeg', quality: 1},
            html2canvas: {
                windowWidth: 1400,
                scale: 2, // qualité
                useCORS: true // important si tu as des images
            },
            jsPDF: {
                unit: 'cm',
                format: [25, 35.4],
                orientation: 'portrait'
            },
            // pagebreak: { mode: 'avoid-all' }
        };

        document.body.classList.add('pdf-export');

        const img = document.querySelector('#watermark-pdf img');
        const runHtml2Pdf = () => {
            document.body.classList.add('pdf-export');
            html2pdf()
                .set(options)
                .from(document.body)
                .save()
                .then(() => {
                    document.body.classList.remove('pdf-export');
                });
        };

        if (img.complete) {
            // Image déjà chargée (en cache), tu peux générer le PDF direct
            runHtml2Pdf();
        } else {
            // Image pas encore chargée, attendre le chargement
            img.onload = () => {
                runHtml2Pdf();
            };
        }
    }

    function generatePdfResume() {
        const filename = document.title + ' - Resume.pdf';
        generatePdf(filename);
    }

    function generatePdfFiche() {
        const filename = document.title + ' - Fiche.pdf';
        generatePdf(filename);
    }

    function printSection() {
        window.print()
    }

    async function shareSection() {

        const params = new URLSearchParams();
        let firstName = null;
        let lastName = null;

        for (const [key, value] of Object.entries($globalState)) {
            if (value !== null && value !== undefined && value !== '') {
                params.append(key, value);
            }
            if ('o' === key) {
                firstName = value;
            } else if ('p' === key) {
                lastName = value;
            }
        }

        const urlWork = `${window.location.origin + window.location.pathname}?${params.toString()}`;
        let title = 'Simulateur de salaire';
        let textWork = `Bonjour,\n\nJe voulais te partager cette simulation: ${urlWork}`;
        if (firstName !== null && lastName !== null) {
            title = `Simulateur de salaire - ${firstName} ${lastName}`;
            textWork = `Bonjour,\n\nJe voulais te partager cette simulation pour ${firstName} ${lastName}: ${urlWork}`;
        }

        if (navigator.share) {
            await navigator.share({
                title: title,
                text: textWork,
                url: urlWork,
            });
        } else {
            const subject = encodeURIComponent(title);
            const body = encodeURIComponent(textWork);

            window.location.href = `mailto:?subject=${subject}&body=${body}`;
        }
    }

    function copyLink() {
        const {origin, pathname, hash} = window.location;
        const params = new URLSearchParams();
        let newQuery = null;

        if (hash) {
            // On est en hash mode, il faut reconstruire avec le hash
            const [path, query] = hash.split('?');
            newQuery = `${origin}${pathname}${path}`;
        } else {
            // En history mode, le search est déjà utilisé
            newQuery = `${origin}${pathname}`;
        }

        for (const [key, value] of Object.entries($globalState)) {
            if (value !== null && value !== undefined && value !== '') {
                params.append(key, value);
            }
        }

        const urlWork = `${newQuery}?${params.toString()}`;

        navigator.clipboard.writeText(urlWork)
            .then(() => {
                alert("Lien copié !");
            })
            .catch(err => {
                alert("Erreur lors de la copie : ", err);
            });
    }

    function copyLinkPublic() {
        const {origin, pathname, hash} = window.location;
        const params = new URLSearchParams();
        let newQuery = null;

        console.log('store api_url_public', $api_url_public);

        if (hash) {
            // On est en hash mode, il faut reconstruire avec le hash
            const [path, query] = hash.split('?');
            newQuery = `${$api_url_public}${pathname}${path}`;
        } else {
            // En history mode, le search est déjà utilisé
            newQuery = `${$api_url_public}${pathname}`;
        }

        for (const [key, value] of Object.entries($globalState)) {
            if (value !== null && value !== undefined && value !== '') {
                params.append(key, value);
            }
        }

        const urlWork = `${newQuery}?${params.toString()}`;
        navigator.clipboard.writeText(urlWork)
            .then(() => {
                alert("Lien public copié !");
            })
            .catch(err => {
                alert("Erreur lors de la copie : ", err);
            });
    }

    function copyLinkContract() {

        const locale = "fr";
        const type = "currency";

        const days = result.daysPerMonth;
        const totalBaseGross = result.totalBaseGross
        const netToPayBeforePAS = result.netToPayBeforePAS
        const totalBaseGrossYear = totalBaseGross * 12

        const totalBaseGrossFormattedNumber = new Intl.NumberFormat(locale, {
            style: type,
            currency: "EUR",
        }).format(totalBaseGross);

        const netToPayBeforePASFormattedNumber = new Intl.NumberFormat(locale, {
            style: type,
            currency: "EUR",
        }).format(netToPayBeforePAS);

        const totalBaseGrossYearFormattedNumber = new Intl.NumberFormat(locale, {
            style: type,
            currency: "EUR",
        }).format(totalBaseGrossYear);

        //netToPayAfterPAS:3555.3295
        //netToPayBeforePAS:3555.3295

        let phrase1 = "Salaire brut annuel : {totalBaseGrossYearFormattedNumber} sur une base de {days} jours travaillés par mois hors frais."
            .replace("{totalBaseGrossYearFormattedNumber}", totalBaseGrossYearFormattedNumber)
            .replace("{days}", days);

        let phrase2 = "Salaire brut mensuel {totalBaseGrossFormattedNumber} et salaire net mensuel {netToPayBeforePASFormattedNumber}"
            .replace("{totalBaseGrossFormattedNumber}", totalBaseGrossFormattedNumber)
            .replace("{netToPayBeforePASFormattedNumber}", netToPayBeforePASFormattedNumber);

        navigator.clipboard.writeText(phrase1 + "\n" + phrase2)
            .then(() => {
                alert("Texte copié !");
            })
            .catch(err => {
                alert("Erreur lors de la copie : ", err);
            });
    }

    function getValue(result, key, period = "monthly") {
        let value = 0;

        //let element = lineHeaders.find((element) => element.key === key);

        let periodFactor = 1;
        if (period === "yearly" && key !== "dailyRate") {
            periodFactor = 12;
        }

        value = result[key];
        return value * periodFactor;
    }

    let same = false;
    const before = getValue(result, "netToPayBeforePAS");
    const after = getValue(result, "netToPayAfterPAS");

    if (before === after) {
        same = true;
    }

    let active = 'Simulation du salaire';
    const columnTab = [
        'Simulation du salaire',
        'Résumé du salaire'
    ];
</script>

{#if result}
    <div bind:this={contentRef}>
        <LayoutGrid style="padding: 0">
            <Cell span={3} spanDevices={{ tablet:4, phone: 12 }} class="resume-salary">
                <h2>Résumé
                    {#if privateVersion}
                        <Button on:click={copyLinkContract} variant="raised" class="resume-salary">
                            <Label>Contrat</Label>
                        </Button>
                    {/if}
                </h2>
                <SlideMonth {result} {privateVersion}/>
                <br><br>
                <SlideYear {result} {privateVersion}/>
                <br><br>
                <span class="super footnote">*&nbsp;</span> Avant Prélèvement à la source<br>
                <!--{#if privateVersion}-->
                <span class="super footnote">**</span> Après Prélèvement à la source
                <!--{/if}-->
            </Cell>
            <Cell span={9} spanDevices={{ tablet:8, phone: 12 }} class="no-download">
                <!--{#if privateVersion}-->
                <TabBar tabs={columnTab} let:tab bind:active class="resume-salary">
                    <Tab {tab}>
                        <Label>{tab}</Label>
                    </Tab>
                </TabBar>

                {#if active === 'Simulation du salaire'}
                    <h2>Simulation du salaire
                        <Button on:click={printSection} variant="raised" class="resume-salary">
                            <Label>Imprimer</Label>
                        </Button>
                        <Button on:click={generatePdfFiche} variant="raised" class="resume-salary">
                            <Label>Télécharger</Label>
                        </Button>
                        <!--<Button on:click={shareSection} variant="raised" class="resume-salary">
                            <Label>Partager</Label>
                        </Button>-->
                        <Button on:click={copyLink} variant="raised" class="resume-salary">
                            <Label>Copier le lien</Label>
                        </Button>
                        {#if privateVersion}
                            <Button on:click={copyLinkPublic} variant="raised" class="resume-salary">
                                <Label>Copier le lien public</Label>
                            </Button>
                        {/if}
                    </h2>
                    <Salary {result}/>
                {:else if active === 'Résumé du salaire'}
                    <h2>Résumé du salaire
                        <Button on:click={printSection} variant="raised" class="resume-salary">
                            <Label>Imprimer</Label>
                        </Button>
                        <Button on:click={generatePdfResume} variant="raised" class="resume-salary">
                            <Label>Télécharger</Label>
                        </Button>
                        <!--<Button on:click={shareSection} variant="raised" class="resume-salary">
                            <Label>Partager</Label>
                        </Button>-->
                        <Button on:click={copyLink} variant="raised" class="resume-salary">
                            <Label>Copier le lien</Label>
                        </Button>
                        {#if privateVersion}
                            <Button on:click={copyLinkPublic} variant="raised" class="resume-salary">
                                <Label>Copier le lien public</Label>
                            </Button>
                        {/if}
                    </h2>
                    <Extract {result}/>
                {/if}
            </Cell>
            <Cell span={12} class="download">
                <!--{#if privateVersion}-->
                <TabBar tabs={columnTab} let:tab bind:active class="resume-salary">
                    <Tab {tab}>
                        <Label>{tab}</Label>
                    </Tab>
                </TabBar>

                {#if active === 'Simulation du salaire'}
                    <h2>Simulation du salaire</h2>
                    <Salary {result}/>
                {:else if active === 'Résumé du salaire'}
                    <h2>Résumé du salaire</h2>
                    <Extract {result}/>
                {/if}
            </Cell>
        </LayoutGrid>
    </div>
{/if}

<style>
    :global(.orange) {
        color: var(--mdc-theme-primary, #fc7601);
    }

    .super {
        vertical-align: super;
    }

    .footnote {
        font-size: 0.8em;
    }

    @media print {
        h2 {
            display: none;
        }
    }
</style>
